import { useParams } from "@tanstack/react-router";
import { JudgePage } from "@/modules/scores/presentation/pages/JudgePage";
import { CompetitionJudgeLayout } from "./CompetitionJudgeLayout";

/** Route: `/competition/events/:eventId/judge/:judgeNumber` */
export function CompetitionJudgeEventPage() {
  const params = useParams({ strict: false }) as {
    eventId?: string;
    judgeNumber?: string;
  };
  const judgeNum = Number(params.judgeNumber);
  const eventId = params.eventId;

  if (!eventId || !Number.isFinite(judgeNum) || judgeNum < 1 || judgeNum > 3) {
    return null;
  }

  const judgeNumber = judgeNum as 1 | 2 | 3;

  return (
    <CompetitionJudgeLayout eventId={eventId} judgeNumber={judgeNumber}>
      <JudgePage eventId={eventId} judgeNumber={judgeNumber} />
    </CompetitionJudgeLayout>
  );
}
